import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { AppService } from 'src/app/app.service';

@Component({
  selector: 'ajoutpersonnemodal',
  templateUrl: './ajoutpersonnemodal.component.html',
  styleUrls: ['./ajoutpersonnemodal.component.css']
})
export class AjoutpersonneModalComponent implements OnInit {
  @ViewChild('content') modal: TemplateRef<any>;

  constructor(private appService: AppService) { }

  ngOnInit() {
    this.appService.personneModal = this.modal;
  }

  ajoutPersonne() {
    console.log("passe");
  }

}
